import React from 'react'
import { connect } from 'react-redux'
import _ from 'underscore'

import Loader from '../../../../common/components/notifications/Loader'
import RestrictedComponent from '../../../../lib/components/form/RestrictedComponent'
import { Popper, Grow, ClickAwayListener } from '@material-ui/core'
import schema from '../../../../routes/permissions/schema'

class EncoderListing extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isMenuOpen: false,
    }
    this.anchorRef = React.createRef()
  }

  // shouldComponentUpdate (nextProps, nextState) {
  //     return this.props.encoders !== nextProps.encoders ||
  //         this.props.event.assignedEncoder !==
  //         nextProps.event.assignedEncoder ||
  //         this.props.event.encoderDetails !==
  //         nextProps.event.encoderDetails ||
  //         (nextProps.isResolving !== this.props.isResolving)
  //     ;
  // }
  // componentDidMount () {
  //     if (!this.state.requestedEncoders && !this.props.pendingRequest && this.props.encoders === null) {
  //         this.props.requestEncoders()
  //         this.setState({
  //             requestedEncoders: true
  //         })
  //     }
  // }

  handleEncoderSelect(encID, ev) {
    ev.preventDefault()
    this.props.assignEncoder(encID)
  }

  render() {
    var assignedID = this.props.event.assignedEncoder
    var assignedEncoder = assignedID
      ? _(this.props.encoders).findWhere({ encoderID: assignedID })
      : null
    function listing() {
      if (this.props.isResolving) {
        return [
          <li key='encoder-fetch-loader'>
            <Loader message='Fetching' />
          </li>,
        ]
      }

      if (!this.props.encoders.length) {
        return [
          <li key='encoder-null-set'>
            <a className='disabled' href="#" onClick={e => e.preventDefault()}>
              No Available Sources
            </a>
          </li>,
        ]
      }

      const iconStyle = {
        margin: '0 .5em 0 0',
      }

      const elStyle = {
        borderBottom: '1px solid #eee',
      }

      const encoderOptions = this.props.encoders.map(function (encoder, i) {
        return (
          <li className="encoder-menu-option" key={`encoder list item ${encoder.encoderID}`}>
            <a
              key={`encoder list item button${encoder.encoderID}`}
              onClick={(e) => {
                e.preventDefault()
                this.handleEncoderSelect(encoder.encoderID, e)
                this.setState({ isMenuOpen: false })
              }}
              style={{ textOverflow: 'ellipsis', overflow: 'hidden' }}
            >
              {encoder.online ? (
                <i style={iconStyle} className='fa fa-circle success' />
              ) : (
                <i style={iconStyle} className='fa fa-circle danger' />
              )}
              {encoder.simpleName}
            </a>
          </li>
        )
      }, this)
      if (this.props.event.assignedEncoder) {
        encoderOptions.unshift(
          <li className="encoder-menu-option" key='unassign encoder key' style={{borderBottom: '1px solid #c1c1c1'}}>
            <a
              key='link encoder key'
              onClick={(e) => {
                e.preventDefault()
                this.handleEncoderSelect(null, e)
                this.setState({ isMenuOpen: false })
              }}
            >
              Unassign Encoder
            </a>
          </li>
        )
      }
      return encoderOptions
    }

    function title() {
      if (this.props.isResolving) {
        return <span className='title'>Loading ...</span>
      }
      return !assignedEncoder ? (
        <span className='title'>
          No Source Assigned <i className='fa fa-caret-down'></i>
        </span>
      ) : (
        <span className='title' title={assignedEncoder.simpleName}>
          Source: {assignedEncoder.simpleName} <i className='fa fa-caret-down'></i>
        </span>
      )
    }

    var encoderStatus = assignedEncoder && assignedEncoder.online ? 'on' : 'off'
    const handleOpenMenu = () => {
      this.setState({
        isMenuOpen: true,
      })
    }
    const handleCloseMenu = () => {
      this.setState({
        isMenuOpen: false,
      })
    }
    return (
      <ClickAwayListener onClickAway={() => handleCloseMenu()}>
        <div className='dropdown' onClick={(e) => e.stopPropagation()}>
          <RestrictedComponent permissionCheck={schema.EVENT.UPDATE_SOURCE_ENCODER}>
            <div className='btn-group' ref={this.anchorRef}>
              <button
                type='button'
                onClick={handleOpenMenu}
                className='btn btn-default dropdown-toggle'
                data-toggle='dropdown'
                disabled={this.props.disabled}
              >
                <span className={'encoder-status ' + encoderStatus}>
                  <i
                    className={`fa fa-circle ${
                      encoderStatus === 'on' ? 'success' : 'danger'
                    }`}
                  />
                </span>{' '}
                {title.call(this)}
              </button>
              <Popper
                open={this.state.isMenuOpen}
                anchorEl={this.anchorRef.current}
                transition
                disablePortal
                placement={'bottom-start'}
                style={{ zIndex: 4, width: '100%' }}
              >
                {({ TransitionProps }) => (
                  <Grow
                    {...TransitionProps}
                    style={{ transformOrigin: 'center bottom' }}
                  >
                    <ul
                      className='dropdown-menu'
                      style={{
                        display: this.state.isMenuOpen ? 'block' : 'hidden',
                        width: '100%',
                        maxHeight: '300px', // Maximum height for dropdown
                        overflowY: 'auto', // Enable vertical scrolling
                        border: '1px solid #ccc', // Add border for better visuals
                        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)', // Subtle shadow for modern look
                      }}
                    >
                      {listing.call(this)}
                    </ul>
                  </Grow>
                )}
              </Popper>
            </div>
          </RestrictedComponent>
        </div>
      </ClickAwayListener>
    )
  }
}

export default EncoderListing
